/**
 * The `home` plugin: registers the Pyrana landing page at `/`.
 *
 * A dedicated plugin (id "home") so the page's nav id is `page:home`, which the
 * custom sidebar (modules/nav/Sidebar.tsx) takes and pins to the top. The page
 * needs a routeRef + title + icon for the AppNav to surface it in the sidebar.
 */
import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import React from 'react';
import HomeIcon from '@material-ui/icons/Home';

export const homeRouteRef = createRouteRef();

const homePage = PageBlueprint.make({
  params: {
    path: '/',
    routeRef: homeRouteRef,
    title: 'Home',
    icon: React.createElement(HomeIcon),
    // noHeader: the page renders its own <Page>/<Header>/<Content>.
    noHeader: true,
    loader: () =>
      import('../../pages/HomePage').then(m =>
        React.createElement(m.HomePage),
      ),
  },
});

export const homePlugin = createFrontendPlugin({
  pluginId: 'home',
  extensions: [homePage],
});
